import { render, staticRenderFns } from "./editThemeColor.vue?vue&type=template&id=35c4fcf0&lang=pug"
import script from "./editThemeColor.vue?vue&type=script&lang=js"
export * from "./editThemeColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports